/* Name: baseList.tsx
* Copyright: (c) DA-Design Oy
* Creation date: 15.05.2024   (EKn)
*
* Description: 
*/


import { DataGrid } from '@mui/x-data-grid';

const API_SERVER = import.meta.env.VITE_API_SERVER as string;
const BLOB_SIZE_LIMIT = import.meta.env.VITE_API_BLOB_SIZE_LIMIT;
const containerName = `m-sm4-filemanager-updates-blob-container`;

export const FilterButton = (props) => {
  return (
    <button
      type="button"
      className="btn toggle-btn"
      aria-pressed={props.isPressed}
      onClick={() => props.setFilter(props.name)}>
      <span className="visually-hidden">Show </span>
      <span>{props.name}</span>
      <span className="visually-hidden"> tasks</span>
    </button>
  );
}

function listItems({rows, columns, loading}) {

  return(

  <DataGrid getRowId={(row) => row.properties.etag}
    rows={rows}
    columns={columns}
    loading={loading}
    initialState={{
      pagination: {
        paginationModel: { page: 0, pageSize: 5 },
      },
    }}
    pageSizeOptions={[5, 10]}
    checkboxSelection
  />


  );
};

export default listItems;